import React from "react";
import BaseComponent from "../baseComponent";
import BannersComponent from "./advertisersComponent";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import {history} from "../../managers/history";
import {eventConstants, pathConstants} from "../../constants";
import bannerService from "../../services/banner";

export class Banners extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.refreshList()
    }

    refreshList = async () => {
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(bannerService.getBannerList(),);
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch banners");
        this.setState({bannerList: res})
    };
    onAddNewAdvertiserClicked = () => {
        history.push(pathConstants.DASHBOARD_MENU.ADD_BANNERS);
    };

    render() {
        return (
            <BannersComponent
                state={this.state}
                refreshList={this.refreshList}
                onAddNewAdvertiserClicked={this.onAddNewAdvertiserClicked}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Banners);
